import React, { useEffect, useState, useRef } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { useMediaQuery } from 'react-responsive'
import { Routes, Route, useNavigate, useParams } from "react-router-dom";
import { sk } from './globals.js';
import { Button, TextField, Select, IconButton, Paper } from '@mui/material';
import { SaveLogin, SaveToken, SaveUser } from './items.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme2-6.css";
import { styles } from './styles.js';
import { ItemList } from './item_list.js';
import { faEdit, faFaceFrown, faFileLines, faList, faPeace, faPen, faPrint, faTableCells } from '@fortawesome/free-solid-svg-icons';



export const LogoutUser = (props) => {
    const navigate = useNavigate();


    useEffect(() => {

        var today = new Date();
        SaveToken(null);
        navigate('/login');

        return () => {
        };

    }, []);
    return (
        <div></div>
    )

};

